<template>
  <b-modal
    v-model="localShow"
    ok-title="ذخیره"
    cancel-title="انصراف"
    cancel-variant="outline-secondary"
    centered
    title="جزئیات درخواست زائرکارت"
    :no-close-on-backdrop="true"
    size="lg"
    @ok="onSave"
  >
    <b-col cols="12">
      <b-row class="mt-15">
        <b-col cols="4">
          <div class="modal-item-title">
            نام و نام خانوادگی
          </div>
          <div>{{ localRequest.FirstName }} {{ localRequest.LastName }}</div>
        </b-col>
        <b-col cols="4">
          <div class="modal-item-title">
            شماره تماس
          </div>
          <div>{{ localRequest.Phone }}</div>
        </b-col>
        <b-col cols="4">
          <div class="modal-item-title">
            تاریخ ثبت
          </div>
          <div>{{ localRequest.CreatedAt | date('jYYYY-jMM-jDD') }} {{ localRequest.CreatedAt | date('HH:mm') }}</div>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="4">
          <div class="modal-item-title">
            مقصد سفر
          </div>
          <div>{{ localRequest.Destination || '—' }}</div>
        </b-col>
        <b-col cols="4">
          <div class="modal-item-title">
            نوع سفر
          </div>
          <div>{{ localRequest.TripType || '—' }}</div>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12">
          <div class="modal-item-title">
            آدرس
          </div>
          <div>{{ localRequest.Address || '—' }}</div>
        </b-col>
      </b-row>
    </b-col>

    <b-col class="mt-1">
      <b-row>
        <b-col md="4">
          <b-form-group
            label="وضعیت"
            label-for="Status"
          >
            <v-select
              v-model="localRequest.Status"
              :options="enums('ZaerCardStatus')"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>

  </b-modal>
</template>

<script>
export default {
  name: 'ZaerCardDetails',

  props: {
    value: Boolean, // v-model
    request: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localShow: this.value,
      localRequest: JSON.parse(JSON.stringify(this.request)),
    }
  },
  watch: {
    value(val) {
      this.localShow = val
    },
    localShow(val) {
      this.$emit('input', val)
    },
    request: {
      deep: true,
      handler(val) {
        this.localRequest = JSON.parse(JSON.stringify(val))
      },
    },
  },
  methods: {
    onSave() {
      this.$emit('save', this.localRequest)
    },
  },
}
</script>

<style scoped>
.modal-item-title{
  font-weight: 600;
  color: #5e5873;
  font-size: 0.857rem;
  margin-bottom: 0.2857rem;
}
</style>
